import { createApiCall } from 'lib/base';

const DELETE_HOME_WIDGET_MENU_ITEM = 'DELETE_HOME_WIDGET_MENU_ITEM';

const deleteHomeWidgetMenuItemApi = createApiCall<{ id: string }>(
  DELETE_HOME_WIDGET_MENU_ITEM,
  ({ id }) => ({
    endpoint: `api/admin/home-widget-menu-items/${id}`,
    method: 'DELETE',
  })
);

export default deleteHomeWidgetMenuItemApi;
